












































import { Component, Prop, Watch } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";
import VueQuillEditor from "vue-quill-editor";
Vue.use(VueQuillEditor);
import QErrors from "@/common/qErrors.vue";
import { formatImageUrl } from "@/common/utils";
import uploadFile from "@/components/common/uploadFile.vue";
import linkifyHtml from "linkify-html";
import _Quill from "quill";
import BlotFormatter from "quill-blot-formatter";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

const Quill = _Quill;
Quill.register("modules/blotFormatter", BlotFormatter);

@Component({
  name: "qEditor",
  components: {
    VueQuillEditor,
    uploadFile,
    QErrors,
  },
})
export default class QEditor extends Vue {
  @Prop({
    required: true,
  })
  public value: any;

  @Prop({
    default() {
      return {
        background: "#fff",
        color: "#111",
        fontSize: "1.6rem",
        border: "#b4b4b4 1px solid",
        borderRadius: "4px",
        lineHeight: "1",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "0.5em",
      };
    },
  })
  public styleConfig: any;
  @Prop({
    default() {
      return {
        placeholder: "",
        video: true,
        videoEmbed: true,
        modules: {
          blotFormatter: {
            aligner: false,
          },
          toolbar: {
            container: [
              [{ header: [2, 3, false] }],
              ["bold", "italic", "underline", "strike"],
              [{ color: [] }, { background: [] }],
              ["image", "video", "link"],
            ],
          },
        },
      };
    },
  })
  public config: any;

  @Prop({
    default: false,
  })
  public isAutoLink: boolean;

  @Prop({
    default: true,
  })
  public isShowToolbar: boolean;

  public localValue = null;
  public uploading = false;
  public uploadOptions = {
    acceptedFiles: ".jpg, .jpeg, .png",
    maxFilesize: 5, // 5mb
  };
  public errors = {};

  public quillEditor: any;
  public quill: any;

  public mounted() {
    this.quillEditor = this.$refs.myQuillEditor;
    this.quill = this.quillEditor.quill;
    if (this.quill.getModule("toolbar")) {
      this.quill.getModule("toolbar").addHandler(
        "image",
        function() {
          this.handleImageClick();
        }.bind(this),
      );
    }
  }

  @Watch("value")
  public changeSelected(): void {
    if (this.value != this.localValue) {
      const delta = this.quill.clipboard.convert(this.value);
      this.quill.setContents(delta);
    }
  }

  public handleImageClick() {
    if (this.quill) {
      const range = this.quill.getSelection();
      if (range) {
        (this.$refs.myVueDropzone as uploadFile).open();
      }
    }
  }

  public change() {
    this.$emit("input", this.localValue);
    this.$emit("inputPlain", this.quill.getText());
  }

  public clearError() {
    this.$emit("clearError");
  }

  public formatText() {
    if (this.isAutoLink && this.localValue && this.localValue.length > 0) {
      let text = this.localValue
        .replace(/<[^>]*a>/g, "")
        .replace(/<a[^>]*>/g, "");
      text = linkifyHtml(text, {
        target: "_blank",
      });

      const delta = this.quill.clipboard.convert(text);
      this.quill.setContents(delta);
    }
    this.$emit("input", this.localValue);
    this.$emit("inputPlain", this.quill.getText());
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public changeFile(files: []) {
    for (const file of files) {
      const range = this.quill.getSelection();
      if (range) {
        this.quill.insertEmbed(
          range.index,
          "image",
          formatImageUrl((file as any).filePath, "x"),
        );
      }
    }
    (this.$refs.myVueDropzone as uploadFile).reset();
  }

  public uploadStatus(flag) {
    this.uploading = flag;
  }

  public pushError(message) {
    this.$emit("pushError", message);
  }
}
